import { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

import { AUTH_CHECK_UNAVAILABLE, AUTH_NOTICE_CLOSE, AUTH_RATE_LIMITED } from '../constants/auth.strings';
import { subscribeToRequestNotices, type RequestNoticeKind } from '../services/requestNotice';

const TEXT: Record<RequestNoticeKind, string> = {
  'auth-unavailable': AUTH_CHECK_UNAVAILABLE,
  'rate-limited': AUTH_RATE_LIMITED,
};

// The "please try again" notice (services/requestNotice.ts). Renders nothing until a notice arrives; a repeat while it
// shows keeps the one notice open. Read out politely (role="status"), closes itself after a few seconds.
const RequestNotice = () => {
  const [kind, setKind] = useState<RequestNoticeKind | null>(null);

  useEffect(() => subscribeToRequestNotices(setKind), []);

  return (
    <Snackbar
      open={kind !== null}
      autoHideDuration={8000}
      onClose={(_event, reason) => {
        if (reason !== 'clickaway') setKind(null);
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity="warning"
        variant="filled"
        role="status"
        onClose={() => setKind(null)}
        slotProps={{ closeButton: { 'aria-label': AUTH_NOTICE_CLOSE } }}
        sx={{ width: '100%' }}
      >
        {kind ? TEXT[kind] : ''}
      </Alert>
    </Snackbar>
  );
};

export default RequestNotice;
